const status = ['todo', 'inProgress', 'done']

export default status